import { render, staticRenderFns } from "./VariantValue.vue?vue&type=template&id=b427e13c&"
import script from "./VariantValue.vue?vue&type=script&lang=js&"
export * from "./VariantValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports